import type { PlayerRef } from '../../shared/protocol.js';

export type MentionResult =
  | { kind: 'none' }
  | { kind: 'unknown' }
  | { kind: 'empty'; to: PlayerRef }
  | { kind: 'pm'; to: PlayerRef; text: string };

/**
 * "@Nickname message" in the lobby chat sends a private message (user request 2026-09-27).
 * Nicknames may contain spaces, so the text is matched against the names of online players,
 * longest name first; the name must be followed by a space or the end of the text.
 */
export function parseMention(text: string, players: PlayerRef[]): MentionResult {
  const trimmed = text.trimStart();
  if (!trimmed.startsWith('@')) return { kind: 'none' };
  const rest = trimmed.slice(1);
  const lower = rest.toLocaleLowerCase('fi');
  const byLength = [...players].sort((a, b) => b.displayName.length - a.displayName.length);
  for (const p of byLength) {
    const name = p.displayName.toLocaleLowerCase('fi');
    if (lower.startsWith(name) && (rest.length === name.length || /\s/.test(rest[name.length]!))) {
      const message = rest.slice(name.length).trim();
      return message ? { kind: 'pm', to: p, text: message } : { kind: 'empty', to: p };
    }
  }
  return { kind: 'unknown' };
}
